import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="requisit-form"
export default class extends Controller {
  // Define targets
  static targets = ["shippingMethod", "addressInfo", "storeInfo"]

  // Get shipping method value
  get shippingMethod() {
    return this.shippingMethodTarget.value
  }

  // Called when controller is connected
  connect() {
    this._toggleShippingInfo()
  }

  // Called when shipping method is changed
  changeShippingInfo() {
    this._toggleShippingInfo()
  }

  // Toggle shipping info
  _toggleShippingInfo() {
    // Check shipping method equal to "address"
    // If true, show address fields, else hide
    if (this.shippingMethod) {
      if (this.shippingMethod === "address") {
        this.addressInfoTarget.classList.remove("d-none")
        this.storeInfoTarget.classList.add("d-none")
      } else if (this.shippingMethod === "store") {
        this.addressInfoTarget.classList.add("d-none")
        this.storeInfoTarget.classList.remove("d-none")
      } else {
        this.addressInfoTarget.classList.add("d-none")
        this.storeInfoTarget.classList.add("d-none")
      }
    }
  }
}
